import { styled } from '@mui/system';
import MuiAutocomplete from '@mui/material/Autocomplete';
import colors from '../../assets/colors';

const StyledAutocomplete = styled(MuiAutocomplete)({
  color: colors.agroweGreen,
  borderColor: colors.agroweGreen,
  marginRight: 25,
  marginBottom: 20,
  minWidth: 275,
  borderRadius: '4px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: `1.5px solid ${colors.agroweGreen}`,
    },
    '&:hover fieldset': {
      opacity: 0.6,
      border: `1.5px solid ${colors.agroweGreen}`,
    },
    '&.Mui-focused fieldset': {
      border: `1.5px solid ${colors.agroweGreen}`,
    },
  },
});

const Autocomplete = (props) => <StyledAutocomplete {...props} />;
export default Autocomplete;
